// ContentSection.js
import React from 'react';
import './ContentSection.css';

const ContentSection = () => {
  // ✅ Your smart link — auto-detects device and opens the correct store
  const BOOK_NOW_URL = 'https://link-my.app/qslot';

  return (
    <section className="content-section">
      <div className="content-container">
        {/* Left Side: Fixed Highlighted Image */}
        <div className="content-image-wrapper">
          <div className="content-image-frame">
            <img
              src="/img/phone.png"
              alt="Premium Car Wash Service"
              className="content-image"
            />
            {/* Highlight Badge overlay */}
            <div className="image-badge">
              <span className="image-badge-icon">✨</span>
              <span className="image-badge-text">Premium Quality</span>
            </div>
          </div>
          {/* Decorative glow behind image */}
          <div className="content-image-glow"></div>
        </div>

        {/* Right Side: Content */}
        <div className="content-text">
          {/* Small Tag */}
          <span className="content-tag">CAR CARE &amp; SPORTS</span>

          {/* Main Heading */}
          <h2 className="content-title">
            Book Carwash &amp; Turf <span className="content-title-highlight">near you</span>
          </h2>

          {/* Description */}
          <p className="content-description">
            Find the best car wash at the lowest price with Qslot. Easily book a
            carwash near me and enjoy fast, professional cleaning without
            overspending. Quality car care made affordable.
          </p>

          {/* Feature Pills */}
          <div className="content-features">
            <div className="feature-pill">
              <span className="feature-icon">💧</span>
              <span className="feature-text">Premium Wash</span>
            </div>
            <div className="feature-pill">
              <span className="feature-icon">⚡</span>
              <span className="feature-text">Express Service</span>
            </div>
            <div className="feature-pill">
              <span className="feature-icon">🕐</span>
              <span className="feature-text">24/7 Booking</span>
            </div>
          </div>

          {/* Rating & Trust Section */}
          <div className="content-trust">
            <div className="trust-stars">
              <span className="star">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
            </div>
            <p className="trust-text">
              Trusted by <strong>10,000+</strong> users
            </p>
          </div>

          {/* ✅ CTA Button — opens your smart link */}
          <a
            href={BOOK_NOW_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="content-cta"
            aria-label="Book Now — Download the QSlot App"
          >
            Book Now
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContentSection;